import { useMemo } from "react";

import { useQuery } from "@tanstack/react-query";
import moment from "moment";
import { useParams } from "react-router-dom";

import ProjectAPI from "@/src/api/ProjectAPI";

import type { Moment } from "moment";

function useProjectCreationDate(): Moment | null {
  const { projectSlug } = useParams<{ projectSlug: string }>();

  const getProjectQuery = ProjectAPI.generateQuery({
    fn: ProjectAPI.getProject,
    params: [projectSlug],
  });
  const { data: project } = useQuery({
    ...getProjectQuery,
    enabled: !!projectSlug,
  });

  const insertedAt = project?.inserted_at;

  return useMemo(() => (insertedAt ? moment(insertedAt) : null), [insertedAt]);
}

export default useProjectCreationDate;
